function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M9.33342 24.5736H14.6667L20.6001 28.5203C21.4801 29.1069 22.6667 28.4802 22.6667 27.4136V24.5736C26.6667 24.5736 29.3334 21.9069 29.3334 17.9069V9.9069C29.3334 5.9069 26.6667 3.24023 22.6667 3.24023H9.33342C5.33341 3.24023 2.66675 5.9069 2.66675 9.9069V17.9069C2.66675 21.9069 5.33341 24.5736 9.33342 24.5736Z",
  fill: "#76C440"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6666 15H11.3333C10.7866 15 10.3333 14.5467 10.3333 14C10.3333 13.4533 10.7866 13 11.3333 13H20.6666C21.2133 13 21.6666 13.4533 21.6666 14C21.6666 14.5467 21.2133 15 20.6666 15Z",
  fill: "#76C440"
});

function SvgTotalInterviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalInterviews);
export default __webpack_public_path__ + "static/media/total-interviews.12fc4fbb.svg";
export { ForwardRef as ReactComponent };